jQuery(document).ready(function($) {
    $('footer h3').click(function() {
        const $footer = $(this).closest('footer'),
            $menu = $(this).siblings('ul'),
            $h3 = $footer.find('h3'),
            isActive = $(this).hasClass('active');

        if(!$menu.length) return;

        $h3.removeClass('active');
        if(!isActive)
            $(this).toggleClass('active');
    });
});